import React from 'react';
import PropTypes from 'prop-types';
import { toDangerousReactHtml } from '../../../../helper/to_dangerous_react_html';
import TranslationContainer from '../../../translation/translation_container';
import Translation from '../../../translation/translation';
import { formatToCurrency } from '../../../../../_modules/currency/format_to_currency';

export const Sca25PercentDiscount = ({ priceRaw, currencyIsoCode }) => (
    <div className="buy4pay3-price">
        <div className="buy4pay3-price__label">
            <Translation
                translationKey="product-tile-sca-25-percent-discount-label"
            />
            {' '}
        </div>
        <div className="buy4pay3-price__value">
            <TranslationContainer
                translationKey="product-tile-current-price"
                targetProperty="dangerouslySetInnerHTML"
                transform={toDangerousReactHtml}
                placeholder={{
                    price: formatToCurrency(
                        priceRaw - (priceRaw * 0.25),
                        currencyIsoCode,
                        false,
                        true,
                        { decimalDigits: 2 }
                    )
                }}
            >
                <span className="product-tile__price-current-value" />
            </TranslationContainer>
        </div>
    </div>
);

Sca25PercentDiscount.propTypes = {
    priceRaw: PropTypes.number.isRequired,
    currencyIsoCode: PropTypes.string.isRequired,
};
